import type { infer as zInfer } from "zod/v4";
import * as z from "zod/v4";

export const getAmazonIntegration = {
  name: "getAmazonIntegration" as const,
  input: z.object({}),
  output: z.object({ hasIntegration: z.boolean() }),
};

export type AmazonIntegration = zInfer<typeof getAmazonIntegration.output>;
